import Http from './http';

export const sendContactMessage = ({
    name,
    email,
    subject,
    message
}) => Http.post('send_contact_message', {
    name,
    email,
    subject,
    message
});